import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import intl from 'react-intl-universal';
import Hidden from '@material-ui/core/Hidden';
import Add from '@material-ui/icons/Add';
import Remove from '@material-ui/icons/Remove';
import WarningIcon from '@material-ui/icons/Warning';
import Button from 'src/ui/library/Button';
import { formatFileSize } from 'src/helpers/upload';
import UploadPad from 'src/ui/library/Upload/UploadPad';
import { fileRejectErrorType } from 'src/helpers/upload';
import HistoryDisplayContainer from 'src/ui/library/HistoryDisplay';
import { ConfirmDialog } from 'src/ui/library/Dialog';
import ContentParser from 'src/ui/library/ContentParser';
import Cancel from '@material-ui/icons/Cancel';
import SelectWrapper from 'src/ui/library/SelectWrapper';
import moment from 'moment';
import {
  DOCUMENT_SUPPORTED_FILES,
  DOCUMENT_UPLOAD_MAX_NUM,
  DOCUMENTS_CASE_COMPOSE_URL,
  DOCUMENTS_URL,
  DOC_UPLOAD_TYPES,
} from 'src/constants/constants';
import { toMoment } from 'src/helpers/date';
import { components } from 'react-select';
import DOMPurify from 'dompurify';

export const DocUploadPres = ({
  attachFiles,
  progress,
  documents,
  rejected,
  acceptedFileTypes,
  removeUnsupportedFile,
  saveDetails,
  finish,
  isDisabled,
  history,
  isApplicant,
  show,
  toggleView,
  maxSize,
  multiSelectExceeded,
  toggleDelete,
  delUpload,
  del,
  enableDel,
  showConfirmDialog,
  hideConfirmDialog,
  confirmDialogState,
  onFormChange,
  caseLookupValues,
  documentsFormData,
  documentsFormDataSimplified,
  initDocumentsFormData,
  onCaseSelect,
  selectedCases,
  isCaseSelected,
  isCase,
  isTaskFlow,
  requestCase,
  selectedCase,
  documentUploadFor,
  handleOnDocumentUploadFor,
}) => {
  const [validationError, setValidationError] = useState(false);
  let uploadProps = { acceptedFileTypes, maxSize, numOfFilesUploaded: documents.length, multiSelectExceeded };
  // let isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

  const numberOfColumns = 3;

  const renderValue = props => {
    const { label } = props.data;
    return (
      <components.MultiValueLabel {...props}>
        <span className="label">{`${label}`} </span>
      </components.MultiValueLabel>
    );
  };

  const renderRemove = props => {
    return (
      <components.MultiValueRemove {...props}>
        <Cancel className="del-icon" />
      </components.MultiValueRemove>
    );
  };

  const onValidate = (fields, setErrorFn) => {
    setValidationError(false);
    const { ey_issuedate, ey_expirationdate } = fields;
    if (ey_issuedate && ey_expirationdate) {
      if (toMoment(ey_expirationdate) < toMoment(ey_issuedate)) {
        const errorMsg = (
          <span className="error-msg">
            <WarningIcon />
            <b>Expiration date cannot occur before Issue date</b>
          </span>
        );
        setErrorFn('ey_expirationdate', true, errorMsg);
        setValidationError(true);
      }
    } else if (ey_expirationdate) {
      if (toMoment(ey_expirationdate) < moment()) {
        const errorMsg = (
          <span className="error-msg">
            <WarningIcon />
            <b>Document expired</b>
          </span>
        );
        setErrorFn('ey_expirationdate', true, errorMsg);
      }
    }
  };

  const fnCases = () => {
    let isDisabled = false;
    documentUploadFor.forEach((docType, index) => {
      if (isDisabled) {
        return;
      }
      if (docType === DOC_UPLOAD_TYPES.CASE) {
        if (Object.keys(selectedCases).length > 0) {
          isDisabled = selectedCases[index] ? selectedCases[index].length === 0 : true;
        } else {
          isDisabled = true;
        }
      }
    });
    return isDisabled;
  };

  return (
    <div className="upload">
      {!isTaskFlow && (
        <nav className="bread-crumb">
          <HistoryDisplayContainer
            history={history}
            backUrl={
              selectedCase ? DOMPurify.sanitize(`${DOCUMENTS_CASE_COMPOSE_URL}/${selectedCase}`) : DOMPurify.sanitize(`${DOCUMENTS_URL}`)
            }
          />
        </nav>
      )}
      <header className="header-section">
        <h1>{intl.get('documents.documentUpload.title')}</h1>
        <section className="page-description">
          {intl.get('documents.documentUpload.description')}
          <br />
          Supported file types:{' '}
          {DOCUMENT_SUPPORTED_FILES.map(type => type.toLowerCase())
            .sort()
            .join(', ')}
          .{/*<br />
          Total upload size limit: {DOCUMENT_UPLOAD_TOTAL_MAX_SIZE / (1024 * 1024)}MB.*/}
        </section>
      </header>
      <section className="content-section">
        <UploadPad dropHandler={attachFiles} {...uploadProps} maxSize="15000000" />
        <div className="attach-container rejected">
          {rejected.map((file, i) => (
            <div key={`${file.name}-${i}`} className="attach-file">
              <span className="file-button-container">
                <Button styleType="transparent-button" onClick={() => removeUnsupportedFile(file)}>
                  {intl.get('default.label.okay')}
                </Button>
              </span>
              <span className={`mdi mdi-file file-icon`} />
              {file.name}
              <nav className="nav-bar">
                <span className="file-error">{intl.get('fileUploadError.' + fileRejectErrorType(file))}</span>
              </nav>
            </div>
          ))}
        </div>
        <div className="attach-container">
          {documents && documents.length ? (
            enableDel ? (
              <a className="link" onClick={delUpload}>
                {intl.get('documents.documentUpload.delete')}
              </a>
            ) : (
              <span className="disabled-link">{intl.get('documents.documentUpload.delete')}</span>
            )
          ) : null}
          {documents &&
            documents.map((file, i) => (
              <Fragment key={`${file.name}-${i}`}>
                <button
                  className="attach-file"
                  aria-expanded={show[i] === 'block' ? true : false}
                  aria-controls={`${file.name.replace(' ', '')}-${i}`}
                  onClick={toggleView.bind(this, i)}>
                  <input
                    type="checkbox"
                    className="delete-input"
                    aria-label="Select or unselect file deletion"
                    onClick={toggleDelete.bind(this, i)}
                  />
                  <span className={`mdi mdi-file file-icon`} />
                  {file.name}
                  <nav className="nav-bar">
                    <span className="file-size">{formatFileSize(file.size)}</span>
                    {documents.length > 1 && documents.length < DOCUMENT_UPLOAD_MAX_NUM ? ( // only show expand/collapse if there is more than one doc
                      show[i] === 'block' ? (
                        <Remove className="icon" />
                      ) : (
                        <Add className="icon" />
                      )
                    ) : null}
                  </nav>
                  <div className="upload-progress-bar" style={{ width: `${progress}%` }} />
                </button>
                <div
                  className="dropdown-container"
                  id={`${file.name.replace(' ', '')}-${i}`}
                  style={{ display: documents.length === 1 ? true : show[i] }}>
                  {!isTaskFlow && (
                    <div className="radio-button-container">
                      <div>
                        <span>Document upload to</span>
                      </div>
                      <div className="radio">
                        <input
                          type="radio"
                          value="option1"
                          color="secondary"
                          checked={documentUploadFor[i] === DOC_UPLOAD_TYPES.CASE}
                          onClick={e => handleOnDocumentUploadFor(true, i)}
                        />
                        <span>Case</span>
                      </div>
                      <div className="radio">
                        <input
                          type="radio"
                          value="option2"
                          checked={documentUploadFor[i] === DOC_UPLOAD_TYPES.PROFILE}
                          onClick={e => handleOnDocumentUploadFor(false, i)}
                        />
                        <span>Profile</span>
                      </div>
                    </div>
                  )}
                  <SelectWrapper
                    label={intl.get('documents.documentUpload.cases.title')}
                    placeholder={intl.get('documents.documentUpload.cases.selectLabel')}
                    options={caseLookupValues.map(c => ({ value: c.id, label: c.name, employeeId: c.props.employeeId }))}
                    value={selectedCases[i]}
                    renderValue={renderValue}
                    renderRemove={renderRemove}
                    multi
                    onChange={val => onCaseSelect(i, val)}
                    disabled={isTaskFlow}
                    loadOptions={requestCase}
                    required={documentUploadFor[i] === DOC_UPLOAD_TYPES.CASE ? 'true' : ''}
                  />
                  <ContentParser
                    key={`${file.name}-${i}-${selectedCases[i] ? selectedCases[i].map(c => c.label).join('') : ''}`}
                    className="document-upload-form"
                    readOnly={false}
                    data={documentsFormData && documentsFormData[i] ? documentsFormData[i] : initDocumentsFormData}
                    numberOfColumns={numberOfColumns}
                    showLabels={false}
                    debug={false}
                    onValidate={onValidate}
                    onChange={data => onFormChange(data, i)}
                  />
                </div>
              </Fragment>
            ))}
        </div>
      </section>
      <div className="admin-actions">
        <div className="actions-button-wrapper">
          {!isTaskFlow && (
            <Hidden xsDown>
              <Button
                styleType="secondary"
                className="action-button"
                onClick={e => {
                  history.goBack();
                }}>
                {intl.get('admin.cmsUpload.cancel')}
              </Button>
            </Hidden>
          )}
          <Button
            className="action-button"
            disabled={isDisabled || validationError || (!isTaskFlow && fnCases())}
            onClick={e => {
              let noCase = false;
              Object.keys(selectedCases).forEach(key => {
                if (selectedCases[key].length <= 0) {
                  noCase = true;
                }
              });

              if (noCase) {
                showConfirmDialog();
              } else {
                finish();
              }
            }}>
            {intl.get('admin.cmsUpload.finish')}
          </Button>
        </div>
      </div>
      <div>
        {confirmDialogState && (
          <ConfirmDialog
            open
            title={intl.get('documents.documentUpload.cases.dialogTitle')}
            confirmText={intl.get('documents.documentUpload.cases.dialogConfirm')}
            cancelText={intl.get('documents.documentUpload.cases.dialogCancel')}
            onCancel={hideConfirmDialog}
            onConfirm={() => finish()}></ConfirmDialog>
        )}
      </div>
    </div>
  );
};

DocUploadPres.propTypes = {
  documents: PropTypes.array.isRequired,
  attachFiles: PropTypes.func.isRequired,
  finish: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isApplicant: PropTypes.bool.isRequired,
  show: PropTypes.array.isRequired,
  toggleView: PropTypes.func.isRequired,
  toggleDelete: PropTypes.func.isRequired,
  delUpload: PropTypes.func.isRequired,
  del: PropTypes.array.isRequired,
  enableDel: PropTypes.bool.isRequired,
};
export default DocUploadPres;
